<template>
	<component
		v-if="loadedComponent"
		:is="loadedComponent"
		:ref="setChildrenRefs"
		:forward-ref="setChildrenRefs"
		v-bind="$attrs"
		v-on="$listeners"
	>
		<!-- 具名插槽 PS:vue2不支持 slots 动态渲染 -->
		<template v-for="slotName in supportedSlotNames" v-slot:[slotName]="slotProps">
			<slot :name="slotName" v-bind="slotProps ?? {}" />
		</template>
		<!-- 默认插槽 -->
		<template v-slot:default="slotProps">
			<slot v-bind="slotProps ?? {}" />
		</template>
	</component>
	<div v-else-if="showFallback" class="smart-display-fallback">
		<SurfContentEmpty v-if="isSurfTmpl" />
		<Empty v-else />
	</div>
</template>

<script>
export default {
	name: 'SmartDisplayComponent',
	inheritAttrs: false
};
</script>

<script setup>
import { shallowRef, ref, onMounted, watch } from 'vue';
import { useComponentResolver } from '@rebuild/hooks/comp/useComponentResolver.js';
import { useCommonData } from '@/hooks';
import SurfContentEmpty from '@rebuild/materials/shared/common/surf/SurfContentEmpty.vue';

const props = defineProps({
	compId: {
		type: String,
		default: ''
	},
	mode: {
		type: String,
		default: ''
	}
});

const { resolveComponent, supportedSlotNames } = useComponentResolver('display');
const loadedComponent = shallowRef(null);
const showFallback = ref(false);
const reloadComponent = () => {
	const result = resolveComponent(props.compId, props.mode);
	if (result?.component) {
		loadedComponent.value = result.component;
	} else {
		showFallback.value = true;
	}
};

const { isSurfTmpl } = useCommonData();

onMounted(() => {
	reloadComponent();
});
watch(
	() => props.mode,
	() => reloadComponent()
);

const childrenRefs = ref(null);
const setChildrenRefs = el => {
	childrenRefs.value = el;
};
defineExpose({
	get child() {
		return childrenRefs.value;
	}
});
</script>

<style lang="less" scoped></style>
